const carriageReturnOrNewlinePattern = /[\r\n\t]/g;
const validUrlPattern =
  // eslint-disable-next-line no-useless-escape
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i; // eslint-disable-line no-useless-escape

export const getCleanedUrl = (url: string) => {
  // Remove carriage returns
  let cleanedUrl = url.replace(carriageReturnOrNewlinePattern, "");

  // Check if matches the valid URL pattern
  if (!validUrlPattern.test(cleanedUrl)) {
    cleanedUrl = "";
  }

  return cleanedUrl;
};
